import React from 'react';
import ChartInputsBloc from 'components/ChartInputsBloc';

const ChartInputs = ({ vintageOptions, onChange }) => (
  <ChartInputsBloc vintageOptions={vintageOptions} onChange={onChange} />
);

export default ChartInputs;
